/* eslint-disable @typescript-eslint/no-explicit-any */
import { Observable } from "rxjs";

export interface ITheme {
	id: string;
	name: string;
	business?: any;
	colors: {
		main: string;
		primary: string;
		secondary: string;
	}
}

export interface IThemeService {
	current$: Observable<string>
	install(...themes: ITheme[]): void
	useTheme(value: string): void
}

export abstract class BusinessThemeService {
	abstract getThemed(key: string): Observable<any>;
}
